import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const ProfessionalIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10.45 12.805c0 .258-.21.468-.467.468H7.986a.47.47 0 0 1-.467-.468v-.873c-.153 0 .306.095-5.74-1.294v3.851c0 .809.658 1.466 1.467 1.466h11.477c.809 0 1.466-.657 1.466-1.466V10.64l-5.739 1.214z"
      ></path>
      <path
        fill="currentColor"
        d="M16.002 4.509H1.998A1 1 0 0 0 1 5.507v3.247c0 .436.301.814.726.912l5.793 1.33V9.811c0-.258.209-.468.467-.468h1.996c.259 0 .468.21.468.468v1.086l5.824-1.231A.936.936 0 0 0 17 8.754V5.507a1 1 0 0 0-.998-.998"
      ></path>
      <path
        fill="currentColor"
        d="M8.454 10.279h1.06v2.058h-1.06zM7.706 2.98h2.557v.593h.936v-1.06a.47.47 0 0 0-.468-.468H7.238a.47.47 0 0 0-.468.468v1.06h.936z"
      ></path>
    </svg>
  );
};

export default ProfessionalIcon;
